
<section
[@parentAnimation]="{
    value: o.isActivated ? 'opened' : 'closed',
    params:{
        left:elemLeft,
        top:elemTop,
        screentop:screenTop,
        width:elemWidth,
        height:elemHeight,
        right:elemRight,
        bottom:elemBottom,
        widthback:elemWidthBack,
        heightback:elemHeightBack,
        leftback:elemLeftBack,
        rightback:elemRightBack,
        bottomback:elemBottomBack,
        topback:elemTopBack,
        fullwidth:screenWidth,
        fullheight:(screenHeight + 10),
        titlefont: titleFont,
        subtitlefont: subTitleFont,
        fulltitlefont: fullTitleFont,
        fullsubtitlefont: fullSubTitleFont,
        titleLineH: titleLineH,
        fullTitleLineH: fullTitleLineH,
        subTitleLineH: subTitleLineH,
        fullSubTitleLineH: fullSubTitleLineH,
        wrapperTop:wrapperTop,
        wrapperTopBack:(wrapperTop - 5),
        wrapperTopFull:(wrapperTopFull - 7)
     }}"
    (@parentAnimation.done) = "reactivate($event)"
    class="transition-2"  [ngClass]="{'grid-transform':activeGrid}"
>
    <div id="main-grid" 
        mouseWheel
        (mouseWheelDown)="mouseWheelDownFunc($event)"
        (mouseWheelUp)="mouseWheelUpFunc($event)"
        (keyup.arrowdown)="onScrollDown()"
        (keyup.arrowup)="onScrollUp()"
        #gridcontainer
        [ngStyle]="{'transform': 'translateY(' + counter + 'px)', '-webkit-transform': 'translateY(' + counter + 'px)', '-moz-transform': 'translateY(' + counter + 'px)', '-o-transform': 'translateY(' + counter + 'px)'}" 
        class="works-container page-container transition-grid page-padding"
        [ngClass]="{'prevent-animation':stopScrollAnimation}">
            <div *ngIf="screenWidth > 767" id="scroll-grid" class="grid" [@fadeAnimation]="finalWorkPosts?.length">
                <div #workitems id="grid-items-wrapper" class="single-work" *ngFor="let workgrid of finalWorkPosts; let i = index;" 
                    [ngClass]="{'grid-item-8': workgrid.post_size == 8,
                                'grid-item-4': workgrid.post_size == 4,
                                'grid-item-2': workgrid.post_size == 2,
                                'grid-item-1': workgrid.post_size == 1}">
                    <div *ngFor="let work of works|workFilter:workgrid.id" id="post-{{workgrid.slug}}" class="position-relative"
                        [ngClass]="{'H-100-grid': workgrid.post_size == 8 || workgrid.post_size == 4,
                                    'H-50-grid': workgrid.post_size == 2 || workgrid.post_size == 1}">
                        <app-work
                        id="post-item-{{work.slug}}"
                        class="post-page-wrapper" 
                        [attr.data-index]="i"
                        [ngClass]=" {
                        'H-100-grid': workgrid.post_size == 8 || workgrid.post_size == 4,
                        'H-50-grid': workgrid.post_size == 2 || workgrid.post_size == 1,
                        'post-active': activeItem == i}"
                        [work]="work" 
                        [counter]="counter"
                        [postsize]="workgrid.post_size"
                        [i]="i"
                        (animationData)="handleAnimation($event)"
                        (animationDataReset)="handleResetAnimation($event)"
                        (emitScroll)="handleScrollPause($event)"
                        >
                        </app-work>
                    </div>
                </div>
            </div>
            <div *ngIf="screenWidth <= 767" id="scroll-grid" class="grid grid-responsive">
                <div #workitems id="grid-items-wrapper" class="single-work" *ngFor="let workgrid of finalWorkPosts; let i = index;" 
                    [ngClass]="{'grid-item-8': workgrid.post_size == 8,
                                'grid-item-4': workgrid.post_size == 4,
                                'grid-item-2': workgrid.post_size == 2,
                                'grid-item-1': workgrid.post_size == 1}">
                    <div *ngFor="let work of works|workFilter:workgrid.id" id="post-{{workgrid.slug}}" class="position-relative"
                        [ngClass]="{'H-100-grid': workgrid.post_size == 8 || workgrid.post_size == 4,
                                    'H-50-grid': workgrid.post_size == 2 || workgrid.post_size == 1}">
                        <app-work
                        id="post-item-{{work.slug}}"
                        class="post-page-wrapper" 
                        [attr.data-index]="i"
                        [ngClass]=" {
                        'H-100-grid': workgrid.post_size == 8 || workgrid.post_size == 4,
                        'H-50-grid': workgrid.post_size == 2 || workgrid.post_size == 1,
                        'post-active': activeItem == i}"
                        [work]="work" 
                        [counter]="counter"
                        [postsize]="workgrid.post_size"
                        [i]="i"
                        (animationData)="handleAnimation($event)"
                        (animationDataReset)="handleResetAnimation($event)"
                        (emitScroll)="handleScrollPause($event)"
                        >
                        </app-work>
                    </div>
                </div>
            </div>
            <div *ngIf="works && screenWidth <= 1024" class="w-100 H-100 H-100-full  H-auto-tablet  footer-top-border">
            <app-footer></app-footer>
            </div>

            <div *ngIf="noResults && screenWidth > 1024" class="w-100 H-100 H-100-full overflow-hidden remove-grid-borders">
                <div class="no-result-wrapper">
                    <div class="no-result" [ngClass]="{'active': noResultsFade}">
                        <h1 class="heading1">No Results.</h1>
                        <h3 class="heading3 separate-top-6">Try something else</h3>
                        <a class="link1 link-darker f-darker separate-top-5" (click)="removeNoResult()" routerLink="/works">View All Work</a>
                    </div>
                </div>
            </div>
            <div *ngIf="works && screenWidth > 1024" class="w-100 H-100 H-100-full overflow-hidden remove-grid-borders">
                <app-footer></app-footer>
            </div>
        </div>
</section>
<div *ngIf="screenWidth > 767" class="d-none d-lg-block fade-overlay-menu" [ngClass]="{'active': activateMenuOverlay}"></div>
<main class="outlet-grid"  
    [@childAnimation]="o.isActivated ? o.activatedRoute : ''">
    <router-outlet class="router-outlet" #o="outlet"></router-outlet>
</main>